import axios from 'axios'
import {
    GET_CREDITS_V2,
    GET_CREDIT_V2,
    GET_CALC_SIMPLE_V2,
    GET_CALC_FULL_V2,
} from '../utils/endpoints/CreditV2Endpoints'

/** Lista créditos activos productTypeId=5 Avantthya */
export const getAllCreditsV2 = () => axios.get(GET_CREDITS_V2)

export const getCreditV2 = (id: number) => axios.get(GET_CREDIT_V2(id))

export const getCreditResultsV2 = (creditId: number, idplazo: number, amount: number) =>
    axios.get(GET_CALC_SIMPLE_V2(creditId, idplazo, amount))

export const getAmortizationTableV2 = (creditId: number, idplazo: number, amount: number) =>
    axios.get(GET_CALC_FULL_V2(creditId, idplazo, amount))
